export const getRootPageRoute = () => {
    return '/';
}

export const getMtpDetailsPageRoute = () => {
    return '/:id';
}
export const getMtpDetailsByIdPageRoute = (id: number) => {
    return `/${id}`;
}

export const getPersonPageRoute = () => {
  return '/user-personal-account';
}

export const getTransitCentersPageRoute = () => {
  return '/transit-centers';
}